import React, { useEffect, useState, useCallback } from 'react';
import InventoryLedgerList from './InventoryLedgerList';

const InventoryLedger = () => {

  return (
    <div className="card shadow-lg main-card" style={{ position: 'relative' }}>
      <div className="card-header bg-secondary text-white">
        <h4 className="mb-0 h6 fw-semibold">{"Inventory Ledger"}</h4>
      </div>
      <div className="card-body" style={{ overflow: "visible", paddingTop: "1rem" }}>
        <InventoryLedgerList />
      </div>
    </div>
  );
};

export default InventoryLedger;
